export default "__VITE_ASSET__Cw35uK8h__"